import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';

const BASE_URL = 'https://www.patagonia-chain.com';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(
    private meta: Meta,
    private router: Router,
    @Inject(DOCUMENT) private doc: Document,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateCanonicalUrl(event.urlAfterRedirects);
      }
    });
  }

  private updateCanonicalUrl(routeUrl: string): void {
    const path = routeUrl.split('?')[0].split('#')[0];
    const canonicalUrl = path === '/' ? `${BASE_URL}/` : `${BASE_URL}${path}`;

    let link: HTMLLinkElement = this.doc.querySelector('link[rel="canonical"]');
    if (!link) {
      link = this.doc.createElement('link');
      link.setAttribute('rel', 'canonical');
      this.doc.head.appendChild(link);
    }
    link.setAttribute('href', canonicalUrl);

    this.meta.updateTag({ property: 'og:url', content: canonicalUrl });
  }

  setFaqSchema(faqs: { question: string; answer: string }[]): void {
    this.removeFaqSchema();
    if (!faqs.length) return;

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map(faq => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };

    const script = this.doc.createElement('script');
    script.setAttribute('type', 'application/ld+json');
    script.setAttribute('id', 'faq-schema');
    script.text = JSON.stringify(schema);
    this.doc.head.appendChild(script);
  }

  removeFaqSchema(): void {
    const existing = this.doc.getElementById('faq-schema');
    if (existing) existing.remove();
  }
}
